import {
  selectOwner,
  selectServiceAreas,
  selectOwnerError,
  selectStorefront,
  selectStorefrontError,
  selectDestinationSelectSetting,
} from '../core/reducers/owner.reducer';

export const getOwner = selectOwner;
export const getServiceAreas = selectServiceAreas;
export const getStorefrontOrOwnerOrServiceAreasError = selectOwnerError;
export const getStorefront = selectStorefront;
export const getStorefrontError = selectStorefrontError;
export const getDestinationSelectSetting = selectDestinationSelectSetting;
